export default {
  // Tryby
  "common.mode.auto": "Autokonsumpcja",
  "common.mode.economy": "Tryb ekonomiczny",
  "common.mode.exigency": "Tryb awaryjny",

  // Urządzenia
  "common.grid": "Sieć elektryczna",
  'common.evChargers': 'Ładowarki EV',
  'common.evCharger': 'Ładowarka EV',
  'common.pv': 'Fotowoltaika',
  'common.inverter': 'Inwerter',
  'common.pcs': 'Inwerter + Bateria',
  'common.terminal': 'Urządzenie końcowe',
  'common.airc': 'Klimatyzacja',
  'common.engine': 'Silnik',
  'common.battery': 'Bateria',
  'common.metter': 'Licznik energii',
  'common.other': 'Inne',
  "common.power": "Moc",
  "common.powerTotal": "Moc całkowita",
  "common.voltage": "Napięcie",
  "common.electricity": "Energia elektryczna",
  "common.current": "Prąd",
  "common.homeUsage": "Całkowite obciążenie domu",
  "common.battery.power": "Moc baterii",

  // Dane
  "common.noDataAvailable": 'Brak dostępnych danych~',
  'common.tips': 'Wskazówka',
  "common.reset": "Resetuj",
  "common.currencyUnit": '¥',
  "common.submiting": 'Wysyłanie, proszę czekać...',
  "common.close": 'Zamknij',
  "common.from": 'Z',
  "common.useIn": 'Używane w',
  "common.energyPercent": 'Procent przepływu energii',
  "common.dataFlow": "Przepływ danych",
  "common.getDataIng": 'Pobieranie danych, proszę czekać...',
  "common.pageLoading": 'Ładowanie strony, proszę czekać...',
  "common.reseting": "Resetowanie zawartości strony, proszę czekać...",
  "common.save": 'Zapisz',
  "common.onlyNumberTips": "Można wpisywać tylko liczby",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault":"Usterka",
  "common.charge": "Ładowanie",
  "common.discharge": "Rozładowywanie",
  "common.buy": "Kupno",
  "common.sell": "Sprzedaż",
  "common.loadingInfo": 'Ładowanie, proszę czekać...',

  // 
  "common.moreFeatures": "Więcej funkcji",
  "common.confirm": 'Potwierdź',
  "common.saveing": "Zapisywanie, proszę czekać...",
  "common.searchPlacholder": "Wpisz słowo kluczowe",
  "common.iSee": 'Rozumiem',
  "common.pageErrorTips1": "Ups, wystąpił błąd strony~",
  "common.pageErrorTips2": "Spróbuj odświeżyć stronę lub skontaktuj się z obsługą klienta~",
  "common.refresh": "Odśwież",
  "common.backToHome": "Powrót do strony głównej",
  "common.checkTips": "Sprawdzanie, proszę czekać...",
  "common.back": "Wstecz",
  "common.cancel": "Anuluj",
  "common.optional": "Opcjonalne",
  "common.required": "Wymagane",
  "common.status": "Status",
  "common.statusNoDelete": "Nieusunięte",
  "common.statusDelete": "Usunięte",
  "common.submit": 'Wyślij',
  "common.disable": "Wyłącz",
  "common.enable": "Włącz",
  "common.year": 'rok',
  "common.month": 'miesiąc',
  "common.day": 'dzień',
  "common.version": 'Wersja:',
  "common.backHome": ' Powrót do strony głównej',
  "common.backHomeSorry": ' Przepraszamy, strona się zgubiła',
  "common.requestTips1": 'Dane są przetwarzane, nie wysyłaj ponownie',
  "common.requestTips2": "Komunikat systemowy",
  "common.requestTips3": "Sesja logowania wygasła, zaloguj się ponownie",
  "common.requestTips4": "Zaloguj się ponownie",
  "common.requestTips5": "Nieprawidłowa sesja lub sesja wygasła, zaloguj się ponownie",
  "common.requestTips6": "Błąd serwera, spróbuj ponownie później.",
  "common.requestTips7": "Przekroczono czas żądania interfejsu systemowego",
  "common.requestTips8": 'Interfejs systemowy',
  "common.requestTips9": 'Błąd',
  "common.iknow": 'Rozumiem',
  "common.logoutSuccess": "Wylogowano pomyślnie",
  
  // Komponent "Dowiedz się więcej"
  "common.knowMore.title": 'Aby dowiedzieć się więcej, skontaktuj się z BeiNeng',
  "common.knowMore.email": 'Email',
  "common.knowMore.phone": 'Telefon',
  "common.knowMore.wechat": 'WeChat',
  "common.knowMore.website": 'Strona internetowa',
  "common.knowMore.address": 'Adres',
  "common.knowMore.addressDetail": 'Pokój 1205 i 1301, Budynek 5, Nr 8 Qinghe Road, Huangjingkeng, Huangjiang Town, Dongguan City, Guangdong Province',
  
  // Komponent połączenia lokalnego
  "common.localConnection": 'Połączenie lokalne',
  "common.operateInApp": 'Proszę operować w aplikacji!',
  
  "common.enbleStaus": "Status włączenia",
  "common.battery.status": "Bez ładowania i rozładowywania",

  'account.forgetThePassword': 'Zapomniałem hasła',
    'account.logInDirectly': 'Przejdź bezpośrednio do logowania',
    'account.tips1': 'Przekierowanie, proszę czekać...',
    'account.tips2': 'Proszę najpierw przeczytać i zaakceptować warunki użytkowania!',
    'account.autoLogin': 'Auto-logowanie',
    'account.userLogin': 'Logowanie użytkownika',
    'account.registerTips': 'Nie masz jeszcze konta? Kliknij tutaj, aby się zarejestrować',
    'account.userEmail': 'Nazwa użytkownika/Email',
    'account.userEmailTips': 'Wpisz nazwę użytkownika/email',
    'account.password': 'Hasło',
    'account.passwordTips': 'Wpisz hasło',
    'account.submit': "Wyślij",
    'account.submitTips': 'Wysyłanie, proszę czekać...',
    'account.otherLoginTips': 'Lub wybierz inną metodę logowania',
    'account.userRegistration': 'Rejestracja użytkownika',
    'account.userName': 'Nazwa użytkownika',
    'account.userNameTips': 'Wpisz nazwę użytkownika',
    'account.emailTips1': 'Wpisz adres email',
    'account.emailTips2': 'Nieprawidłowy format adresu email',
    'account.phone': 'Numer telefonu',
    'account.phoneTips1': 'Wpisz numer telefonu',
    'account.phoneTips2': 'Nieprawidłowy numer telefonu',
    'account.phoneTips3': 'Wpisz numer telefonu',
    'account.passwordTips1': 'Wpisz hasło o długości 6-30 znaków',
    'account.passwordTips2': 'Nieprawidłowy format hasła. Hasło musi składać się z liter, cyfr, podkreśleń, myślników i kropek, długość 6-12 znaków',
    'account.passwordTips3': 'Hasła nie pasują, sprawdź i spróbuj ponownie!',
    'account.passwordTips4': 'Wpisz hasło. Hasło musi składać się z liter, cyfr, podkreśleń, myślników i kropek',
    'account.passwordTips5': 'Potwierdź hasło',
    'account.passwordTips6': 'Wpisz potwierdzenie hasła',
    'account.passwordTips7': 'Hasła nie pasują, sprawdź i spróbuj ponownie!',
    'account.passwordTips8': 'Wpisz potwierdzenie hasła',
    'account.passwordTips9': 'Gratulacje! Rejestracja powiodła się!',
    'account.passwordTips10': 'Twoja nazwa użytkownika to:',
    'account.emailIs': 'Email to:',
    'account.goToLoginPage': 's nastąpi automatyczne przekierowanie do strony logowania',
    'account.goLogin': 'Zaloguj się',
    'account.goRegister': 'Zarejestruj się',
    'account.loginSuccess': 'Logowanie powiodło się',
    'account.email': 'Email',
    'account.sologn': 'Tworzenie spersonalizowanych rozwiązań energetycznych z troską',
    'account.pleaseAgree': 'Przeczytałem i akceptuję',
    'userAgreement.privacyPolicy': 'Politykę prywatności',

    "account.code": "Kod weryfikacyjny",
    "account.codeTips": "Wpisz kod weryfikacyjny",
    "account.codeTips2": "Nieprawidłowy kod weryfikacyjny",

    "account.inviteCodeTips": "Wprowadź kod zaproszenia",
    "account.inviteCodeHint": "Skontaktuj się z instalatorem lub personelem obsługi i konserwacji, aby uzyskać kod zaproszenia",
    "account.modifyPasswordByAccount": "Zmień hasło przez konto",
    "account.modifyPasswordByEmail": "Zmień hasło przez email",
    "account.getPasswordByAccount": "Odzyskaj hasło przez konto",
    "account.getPasswordByEmail": "Odzyskaj hasło przez email",

    "account.sendEmailTips": "Kod weryfikacyjny wysłany na email, sprawdź skrzynkę",
    "account.name": "Nazwa konta",
    "account.newPassword": "Nowe hasło",
    "account.confirmNewPassword": "Potwierdź nowe hasło",
    "account.nameTips": "Wpisz nazwę konta",
    "account.passwordModifySuccess": "Zmiana hasła powiodła się",
    "account.emailCode": "Kod weryfikacyjny email",
    "account.emailCodeTips": "Wpisz kod weryfikacyjny email",
    "account.emailCodeTips2": "Nieprawidłowy kod weryfikacyjny email",
    "account.emailModifySuccess": "Zmiana hasła powiodła się",
    "account.passworTips1": "Twoje hasło zostało zresetowane!",
    "account.passwordTips11": "Wpisz potwierdzenie hasła",
    "account.passwordTips12": "Wpisz nowe hasło",
    "account.nickname": "Pseudonim użytkownika",
    "account.modifyNickname": "Zmień pseudonim użytkownika",
    "account.modifyNicknameSuccess": "Pseudonim użytkownika zmieniony pomyślnie!",
    "account.nicknameTips": "Wpisz pseudonim użytkownika",
    'account.nicknameError': 'Zmiana pseudonimu użytkownika nie powiodła się!',

    "account.login": 'Zaloguj się',
    'account.quickRegister': 'Szybka rejestracja',
    'account.sendCode': 'Wyślij kod',
    'account.sendTips': 's można wysłać ponownie',
    "account.sendEmailIng": 'Wysyłanie emaila, proszę czekać...',
    'account.emailNotEmpty': 'Adres email nie może być pusty',
    'account.registerAccount': 'Zarejestruj konto',
    'account.registerWelcome': 'Witamy w SusprSafe',
    'account.usernameLimit': 'Nazwa użytkownika musi zaczynać się od litery i może zawierać tylko litery, cyfry, podkreślenia, długość 5-15 znaków',

    'copyright.desc2': 'Informacje o rejestracji strony: Yue ICP-bei 2021169764',

    'editUserInfo.editUserInformation': 'Edytuj informacje użytkownika',
    'editUserInfo.modifyUsername': 'Zmień nazwę użytkownika',
    'editUserInfo.changePictures': 'Zmień zdjęcie profilowe',
    'editUserInfo.savePicturesSuccess': 'Zdjęcie profilowe zapisane pomyślnie',
    'editUserInfo.saveError': 'Zapisywanie nie powiodło się',
    'editUserInfo.pictureLimit':'Obraz musi być mniejszy niż 2MB',
    'editUserInfo.uploadPicture':'Prześlij zdjęcie profilowe',
    'editUserInfo.picturePreview': 'Podgląd',
    
    'editUserInfo.bindPhoneNumber': 'Powiąż numer telefonu',
    'editUserInfo.bindEmail': 'Powiąż email',
    'editUserInfo.changePassword': 'Zmień hasło',

    'editUserInfo.notificationSettings': 'Ustawienia powiadomień',
    'editUserInfo.editAccount': 'Edytuj informacje o koncie',
    'editUserInfo.waitBingting': 'Powiązywanie, proszę czekać...',
    'editUserInfo.collapse': 'Zwiń',
    'editUserInfo.modifyBinding': 'Zmień powiązanie',
    
    'editUserInfo.emailAddress': 'Adres email',
    'editUserInfo.tips1': 'Powiązanie emaila powiodło się',
    'editUserInfo.tips2': 'Zapisywanie nie powiodło się',
    'editUserInfo.tips3': 'Wysyłanie kodu weryfikacyjnego email, proszę czekać...',
    'editUserInfo.tips4': 'Kod weryfikacyjny wysłany na email xxxx, sprawdź',
    'editUserInfo.tips5': 'Wysyłanie kodu weryfikacyjnego nie powiodło się!',
    'editUserInfo.tips6': 'Numer telefonu już powiązany',
    'editUserInfo.tips7': 'Email już powiązany',
    'editUserInfo.emailTips1': 'Wpisz adres email',
    'editUserInfo.emailTips2': 'Nieprawidłowy format adresu email',
    'editUserInfo.emailTips3': 'xxxxs można wysłać ponownie',
    'editUserInfo.emailTips4': 'Wyślij kod',
    'editUserInfo.emailTips5': 'Kod weryfikacyjny email nie może być pusty',
    'editUserInfo.emailTips6': 'Nieprawidłowy kod weryfikacyjny email',
    'editUserInfo.emailCode': 'Kod weryfikacyjny email',
    'editUserInfo.save': 'Zapisz',

    'editUserInfo.phoneTips1': 'Powiązanie numeru telefonu powiodło się',
    'editUserInfo.phoneTips2': 'Wysyłanie kodu weryfikacyjnego SMS, proszę czekać...',
    'editUserInfo.phoneTips3': 'Kod weryfikacyjny SMS wysłany na telefon xxxx, sprawdź',
    'editUserInfo.phoneTips4': 'Wysyłanie kodu weryfikacyjnego SMS nie powiodło się!',
    'editUserInfo.phoneTips5': 'Wpisz numer telefonu',
    'editUserInfo.phoneTips6': 'Nieprawidłowy format numeru telefonu',
    'editUserInfo.phoneTips7': 'Wyślij kod weryfikacyjny SMS',
    'editUserInfo.phoneTips8': 'Kod weryfikacyjny SMS',
    'editUserInfo.phoneTips9': 'Kod weryfikacyjny telefonu nie może być pusty',
    'editUserInfo.phoneTips10': 'Nieprawidłowy kod weryfikacyjny telefonu',
    'editUserInfo.phone': 'Numer telefonu',


    'editUserInfo.noticeTips1': 'Pobieranie ustawień powiadomień nie powiodło się!',
    'editUserInfo.noticeTips2': 'Ustawienia powiadomień zapisane pomyślnie!',
    'editUserInfo.noticeTips3': 'Powiadomienie o niskim poziomie baterii',
    'editUserInfo.noticeTips4': 'Powiadomienie o zakończeniu ładowania',
    'editUserInfo.errorNotification': 'Powiadomienie o błędzie',
    'editUserInfo.updateNotification': 'Powiadomienie o aktualizacji',
    'editUserInfo.monthlyStatisticsNotification': 'Powiadomienie o miesięcznej statystyce',
    'editUserInfo.notificationMethod': 'Sposób odbioru',

    'editUserInfo.userNameTips1': 'Nazwa użytkownika zapisana pomyślnie',
    'editUserInfo.userNameTips2': 'Zapisywanie nazwy użytkownika nie powiodło się',
    'editUserInfo.userNameTips3': 'Wpisz nazwę użytkownika',
    'editUserInfo.userNameTips4': 'Nieprawidłowy format nazwy użytkownika. Musi składać się z cyfr, podkreśleń i liter',
    'editUserInfo.userNameTips5': 'Wpisz nazwę użytkownika',
    'editUserInfo.userNameTips6': 'Zapisywanie, proszę czekać...',
    'editUserInfo.userName': 'Nazwa użytkownika',

    'editUserInfo.avatorTips': 'Kliknij, aby zmienić zdjęcie profilowe',
    'editUserInfo.verifyCodeTips1': 'Wpisz otrzymany kod weryfikacyjny:',
    'editUserInfo.verifyCodeTips2': 'Dla bezpieczeństwa konta, kliknij przycisk, aby wysłać kod weryfikacyjny na oryginalny numer telefonu:',
    'editUserInfo.verifyCodeTips3': 'Wyślij kod',
    'editUserInfo.verifyCodeTips4': 'Oryginalny telefon zweryfikowany, wpisz nowy numer telefonu do powiązania',
    'editUserInfo.verifyCodeTips5': 'Dla bezpieczeństwa konta, kliknij przycisk, aby wysłać kod weryfikacyjny na oryginalny email:',
    'editUserInfo.verifyCodeTips6': 'Oryginalny email zweryfikowany, wpisz nowy email',
    'editUserInfo.verifyCodeTips7': 'Stare hasło',
    'editUserInfo.verifyCodeTips8': 'Proszę najpierw powiązać email!',
    'editUserInfo.verifyCodeTips9': 'Kod weryfikacyjny wysłany na email, sprawdź skrzynkę',
    "editUserInfo.verifyCodeTips10": ', nastąpi automatyczne przekierowanie do strony logowania',

    "hems.notice.title": "Tytuł powiadomienia", 
   "hems.notice.content": "Treść powiadomienia", 
   "hems.notice.operate": "Operacja",
   "hems.notice.noRead": "Nieprzeczytane",
   "hems.notice.read": "Przeczytane",
   "hems.notice.warning": "Ostrzeżenie",
   "hems.notice.error": "Błąd",
   "hems.notice.success": "Statystyka i rozliczenie",
   "hems.notice.sys": "Informacje systemowe",
   "hems.notice.operateSuccess": "Operacja powiodła się",
   "hems.notice.operateTips": "Wybierz elementy do operacji",

    // Strona główna
   "hems.home.selfuseRate": "Współczynnik autokonsumpcji",
   "hems.home.percent": "Procent",
   "hems.home.todayData": "Dane dzisiejsze",
   "hems.home.todayPowerGeneration": "Dzisiejsza generacja energii",
   "hems.home.salesIncome": "Dochód ze sprzedaży energii",
   "hems.home.saved": "Zaoszczędziłeś",
   "hems.home.reduce": "Zmniejszony ślad węglowy",
   "hems.home.tips1": "Brak danych, nie powiązałeś jeszcze xxxx",
   "hems.home.criticalLoad": "Obciążenie krytyczne",
   "hems.home.keyVoltage": "Napięcie krytyczne",
   "hems.home.householdLoad": "Obciążenie domowe",
   "hems.home.householdVoltage": "Napięcie domowe",
   "hems.home.generalLoad": "Obciążenie ogólne",
   "hems.home.generalVoltage": "Napięcie ogólne",
   "hems.home.batteryHealth": "Stan zdrowotny baterii",
   "hems.home.averageTemp": "Średnia temperatura",
   "hems.home.gridLoad": "Obciążenie sieci",
   "hems.home.toggeleDataSource": "Wyświetlane dane zmienione na:",
   "hems.home.toggleTips": "Czy na pewno chcesz zmienić?",
   "hems.home.modeSending": 'Wysyłanie polecenia trybu, proszę czekać...',
   "hems.home.modeSuccess": "Polecenie zmiany trybu wysłane pomyślnie!",
   "hems.home.isOnline": "Czy online",
   "hems.home.useStatus": "Status użytkowania",
   "hems.home.workModeText": 'Bieżący tryb pracy:',
   "hems.home.toggleDataSourceText": 'Wyświetlane dane zmienione na:',
   "hems.ev.charge.status": "Status ładowania",
   "hems.ev.charge.time": "Czas ładowania",
   "hems.ev.charge.count": "Ilość ładowania w czasie rzeczywistym",
   "hems.ev.charge.status.empty":"Wolny",
   "hems.ev.charge.status.ing":"Ładowanie z podłączonym kablem",
   "hems.ev.charge.status.null":"Kabel podłączony, nie ładuje",
   "hems.ev.charge.status.error":"Usterka",
   "hems.hour":"godzina",
   "hems.minue":"minuta",
   "hems.ev.chagre.number": "Numer ładowarki",

   // Przewodnik użytkownika
   "hems.userGuide.selfUse": "Autokonsumpcja",
   "hems.userGuide.selfUseTips": "Priorytetowe użycie energii słonecznej, uzupełnianie z sieci w przypadku niedoboru",
   "hems.userGuide.economyMode": "Tryb ekonomiczny",
   "hems.userGuide.economyModeTips": "Optymalizuje zużycie energii na podstawie cen energii",
   "hems.userGuide.emergencyMode": "Tryb awaryjny",
   "hems.userGuide.emergencyModeTips": "Zapewnia zasilanie obciążenia krytycznego w pierwszej kolejności",

   // Strona wykresów
   "hems.history.energyStatistics": "Statystyka energii",
   "hems.history.revenueStatistics": "Statystyka dochodów",
   "hems.history.greenStatistics": "Zielony wpływ",
   "hems.history.revenueTitle": "Całkowity dochód ze sprzedaży energii",
   "hems.history.savingsTitle": "Całkowite oszczędności",
   "hems.history.carbonTitle": "Całkowita redukcja emisji dwutlenku węgla",
   "hems.history.day": "Dzień",
   "hems.history.month": "Miesiąc",
   "hems.history.year": "Rok",
   "hems.history.beforeDay": "Poprzedni dzień",
   "hems.history.afterDay": "Następny dzień",
   "hems.history.beforeMonth": "Poprzedni miesiąc",
   "hems.history.afterMonth": "Następny miesiąc",
   "hems.history.beforeYear": "Poprzedni rok",
   "hems.history.afterYear": "Następny rok",
   "hems.history.totalUse": 'Całkowite użycie',
   "hems.history.fullScreen": 'Pełny ekran',
   "hems.history.timeSelect": "Wybór daty",
   "sync.tips1": "Polecenie synchronizacji danych wysłane pomyślnie!",
   "sync.tips2":"Synchronizacja danych w toku, może zająć do pół godziny, wróć później~",
   "sync.tips3": "Synchronizacja danych urządzenia może być opóźniona. Jeśli dane wydają się nieprawidłowe, kliknij:",
   "sync.tips4": "Synchronizuj dane",

   "charge.info": "Informacje o ładowarce",
    "news.loading": 'Ładowanie...',
    "news.noMore": 'Brak więcej',
    "hems.pv.power": 'Zasilanie fotowoltaiczne',

  // Specyficzne dla UEH
  "ueh.sellPower": "Ilość sprzedanej energii",
  
  "menu.home": "Strona główna",
  "menu.history": "Historia",
  "menu.device": "Urządzenia",
  "menu.settings": "Ustawienia",
  "menu.messageCenter": "Powiadomienia",
  "menu.help": "Pomoc i wsparcie",
  "menu.mine": "Moje konto",


  "mine.userSetting": "Ustawienia użytkownika",
  "mine.terminalSetting": "Podstawowe ustawienia terminala",
  "mine.uploadCloud": "Kopia zapasowa danych w chmurze",
  "mine.changeVersion": "Sprawdź aktualizacje",
  "mine.language": "Zmień język",
  "mine.about": "O aplikacji",
  "mine.feedback": "Opinia i feedback",
  "mine.logout": "Wyloguj się",
  "mine.logoutAccount": "Usuń konto",

  "mine.logoutAccountTips": "Usuń konto o nazwie []",
  "mine.logoutAccountTips1": "Usuń powiązane konto []",
  "mine.logoutAccountCare": "Ważne kwestie dotyczące usuwania konta:",
  "mine.logoutAccountCare1": "1. Konto jest w bezpiecznym stanie",
  "mine.logoutAccountCare1-1": "Konto jest obecnie używane normalnie, nie ma ryzyka kradzieży, naruszenia, wyłączenia itp.",
  "mine.logoutAccountCare2": "2. Uprawnienia/powiązania konta zostały anulowane",
  "mine.logoutAccountCare2-1": "Konto zakończyło uprawnienia z usługami stron trzecich.",
  "mine.logoutAccountCare3": "3. Konta nie można odzyskać po usunięciu, wszystkie dane zostaną usunięte",
  "mine.logoutAccountCare3-1": "Po usunięciu konta wszystkie dane i powiązane numery telefonów/adresy email zostaną trwale usunięte.",
  "mine.confirmLogout": "Potwierdź usunięcie",
  "mine.logoutSuccess": "Konto zostało usunięte!",

  "mine.feedbackIssues": "Zgłoś problemy",
  "mine.feedQuantity": "Ilość",
  "mine.feedAmount": "Maksymalnie 9 obrazów, maksymalnie 1MB/obraz",

  "mine.notice.fail": "Pobieranie ustawień powiadomień nie powiodło się!",
  "mine.notice.saveSuccess": "Ustawienia powiadomień zapisane pomyślnie!",
  "mine.notice.saveFail": "Zapisywanie nie powiodło się!",
  "mine.notice.title": "Ustawienia powiadomień",
  "mine.notice.batteryLow": "Powiadomienie o niskim poziomie baterii",
  "mine.notice.chargingFinish": "Powiadomienie o zakończeniu ładowania",
  "mine.notice.error": "Powiadomienie o błędzie",
  "mine.notice.update": "Powiadomienie o aktualizacji",
  "mine.notice.monthly": "Powiadomienie o miesięcznej statystyce",
  "mine.notice.receiveType": "Sposób odbioru",

  "mine.language.welcome": "Witamy w SusprSafe",
  "mine.language.desc1": "Wybierz wersję językową zgodnie z regionem",
  "mine.language.desc2": "Możesz to zmienić w ustawieniach aplikacji w dowolnym momencie",

  "mine.userInfo.avatar":"Zdjęcie profilowe",
  "mine.userInfo.nickname":"Pseudonim",
  "mine.userInfo.password":"Hasło",
  "mine.userInfo.changePassword":"Zmień hasło",
  "mine.userInfo.setPassword":"Ustaw hasło",
  "mine.userInfo.phoneNumber":"Numer telefonu",
  "mine.userInfo.bindPhone":"Powiąż numer telefonu",
  "mine.userInfo.bindEmail":"Powiąż email",
  "mine.loginExpired":"Sesja logowania wygasła, zaloguj się ponownie",
  "mine.userInfo.title":"Informacje użytkownika",
  "mine.userInfo.bind":"Powiąż",
  "mine.userInfo.modify": "Zmień",
  "mine.userInfo.modifyNickname":"Zmień pseudonim",
  "mine.userInfo.userNickname":"Pseudonim użytkownika",
  "mine.userInfo.selectPic":"Wybierz obraz do przesłania",
  "mine.userInfo.saveSuccess":"Zapisano pomyślnie",
  "mine.userInfo.uploadFail":"Przesyłanie nie powiodło się",
  "mine.userInfo.avatarSaveSuccess":"Zdjęcie profilowe zapisane pomyślnie",
  "mine.userInfo.nameTips1":"Pseudonim nie może być pusty",
  "mine.userInfo.nameTips2":"Wpisz pseudonim",

  "common.pleaseSelect": "Proszę wybrać",
  "question.commonQuestions": "Częste pytania",
  "account.toggleLanguage": 'Zmień język',
  "account.localConnection": "Połączenie lokalne",
  "account.selectLanguage": 'Wybierz język',
  "account.sendEmailToast": "Kod weryfikacyjny wysłany na email xxx, sprawdź skrzynkę",
  "account.emailError": "Nieprawidłowy format email",
  "account.sendEmailFail": "Wysyłanie nie powiodło się, spróbuj ponownie",

  "common.submitting": "Wysyłanie, proszę czekać...",

  "device.page.noData": "Brak danych, ta strona wymaga aplikacji do podglądu"
 
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};